export function dSSForEach(dssProp, callback) {
  if (typeof (callback) !== "function") {
    return false;
  }
  switch (dssProp.datatype) {
    case "string":
    case "int":
    case "table":
    case "long":
    case "double":
    case "sheet":
    case "bool":
    case "row":
    case "notification":
      break;
    default:
      break;
  }

  for (let [key, value] of Object.entries(dssProp)) {
    if (key !== "datatype") {
      callback(key, value);
    }
  }
}

export function createDSSRequest(object, command, args) {
  let template = {
    "request": {
      "datatype": "table",
      "action": {
        "datatype": "string",
        "value": command
      },
      // "objectId": {
      //   "datatype": "string",
      //   "value": object
      // },
      "arguments": {
        datatype: "table"
      },
      "requestId": {
        "datatype": "long",
        "value": Date.now()
      }
    }
  };
  if (object !== '') {
    template.request.objectId = {
      "datatype": "string",
      "value": object
    };
  }

  for (let [key, value] of Object.entries(args)) {
    validateArg(key, value);
    template.request.arguments[key] = value;
  }

  return template;
}

//this function checks wether the datatype of your object contains a valid string. if you encounter errors, add your type here.
export function validateArg(index, arg) {
  switch (arg.datatype) {
    case "string":
    case "int":
    case "table":
    case "long":
    case "double":
    case "sheet":
    case "bool":
    case "row":
    case "notification":
      break;
    default:
      console.log("found unclear datatype for index: " + index + " datatype " + arg.datatype, arg);
      break;
  }

  dSSForEach(arg, function (index, value) {
    if (typeof value == "object") {
      if (index == "datatype" || index == "value") {
        console.log('low level index');
      } else {
        validateArg(index, value);
      }
    }
  });
}

export function isAspectAllowedForUser(aspect) {
  let status = false;
  switch (aspect.Type.value) {
    case 'TestAspect03':
    case 'TestAspect':
    case 'BusStop':
    case 'Bus':
    case 'TrafficJam':
    case 'Accident':
    case 'RoadWork':
    case 'EmergencyService':
    case 'RoadRelation':
    case 'Destination':
    case 'INCIDENT':
    case 'Incident':
    case 'ParkingFacility':
    case 'IVERA_VRI_BRIDGE':
    case 'DisperantoDisplay':
    case 'PRISDisplayManager':
    case 'Camera':
    case 'EntryPoint':
    case 'USER':
      status = true;
      break;
    default:
      console.error('isAspectAllowedForUser aspect type not supported', aspect.Type.value, aspect);
      break;
  }
  return status;
}

// }
